import React, { useEffect, useState } from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

type Props = {
  isLoggedIn?: boolean;
};

const PrivacyPolicy = (props: Props) => {
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const userToken: string = currentUser?.jwtToken;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="h-[75px] z-10 fixed mx-10 ">
        <Header
          position={"fixed"}
          isLoggedIn={userToken ? true : false}
          logo={"Yes"}
        />
      </div>
      <div
        className={`rounded-[8px] lg:mx-[30px] m-[20px] lg:mx-8 mx-2 p-[20px] lg:p-[5px]  ${
          window.location.pathname === "/profile/privacy-policy"
            ? ""
            : "mt-[100px]"
        }`}
      >
        <div>
          <div className="text-white mb-2 bg-[#ED1C24] rounded-3xl width-full text-center h-[80px] font-poppins font-semibold lg:text-2xl md:text-2xl text-xl pt-5">
            Privacy Policy
          </div>
          <div className=" p-5">
            <p className="mt-4 text-sm">
              Please read the following carefully. This statement provides
              general information about the privacy statement of this website
              and its related app. Your use of this service constitutes
              acceptance by you of this privacy statement.
            </p>
            <p className="mt-4 text-sm">
              Car Rental (collectively,
              <b>"Car Rental" , </b>
              <b>"we", "our" </b>
              and
              <b> "us"</b>) has created this privacy statement (
              <b>"Statement"</b> ) to demonstrate its firm commitment to the
              privacy of the details that you provide to us when using{" "}
              <mark>https://carrental.rightbraininfotech.in/</mark> and its mobile application
              (collectively
              <b> "the website"</b>
              ). It is mandatory under the
              <b> Information Technology Act 2000 </b>
              to notify and get the consent of users before collecting and
              processing their information. Thus, the Privacy Policy has to be
              visible and understandable to the users.
            </p>
            <p className="mt-4 text-sm">
              At Car Rental, we are committed to maintaining the trust and
              confidence of all visitors to our website. In particular, we want
              you to know that the website is not in the business of selling,
              renting or trading email lists with other companies and businesses
              for marketing purposes.
            </p>
            <p className="mt-4 text-sm">
              We believe your business is no one else’s. Your Privacy is
              important to you and to us. So, we’ll protect the information you
              share with us. To protect your privacy, Car Rental follows
              different principles in accordance with worldwide practices for
              customer privacy and data protection.
            </p>
            <ul className="list-disc mt-4 ml-4 text-sm">
              <li className="text-sm">
                We won’t sell or give away your name, mail address, phone
                number, email address or any other information to anyone.
              </li>
              <li className="text-sm">
                We'll use state–of–the–art security measures to protect your
                information from unauthorized users.
              </li>
            </ul>
            <p className="mt-4 text-sm">
              Therefore, to provide you with our services we need (and sometimes
              are obliged by the law) to collect your personal data. This
              Privacy Policy (the
              <b> "Policy"</b>) informs Users (a
              <b> "User"</b>, or
              <b> "You"</b>) of our policies regarding the processing of
              Personal Information we receive from Users of the website.
            </p>
            <p className="mt-4 text-sm">
              In this Privacy Policy, we’ve provided detailed information on
              when and why we collect personal information, how we use it, the
              limited conditions under which we may disclose it to others, and
              how we keep it secure.
            </p>
            <p className="mt-4 text-sm">
              We take your privacy seriously and take measures to provide all
              visitors and users of the website with a safe and secure
              environment.
            </p>
            <p className="mt-4 text-sm">
              The Personal Information on the website, is collected, controlled
              and processed by the data controller; collected on behalf of;
            </p>
            <p className="mt-4 text-sm">Car Rental </p>
            <p className="mt-4 text-sm">India</p>
            <p className="mt-4 text-sm">
              Telephone: <mark>(020)-4131-2229</mark>{" "}
            </p>
            <p className="mt-4 text-sm">
              EMAIL: <mark>contact@CarRental.app</mark>
            </p>

            <ol className="list-decimal mt-4 ml-4 text-sm">
              <li className="mt-4 text-sm">
                <p className="font-bold ml-4 text-sm">GENERAL</p>
                <ol className="list-disc ml-4 text-sm">
                  <li className="mt-4 text-sm">
                    This Website with the URL of in.CarRental.app (
                    <b>"Website/Site"</b>) is operated by WANDRSTAR TRAVEL
                    TECHNOLOGIES PRIVATE LIMITED (<b>"We/Our/Us"</b>). We are
                    committed to protecting and respecting your privacy. We do
                    collect your personal information and process your personal
                    data in accordance with the IT Act, 2000 (21 of 2000) and
                    other national and state laws which relate to the processing
                    of personal data. Please read the following carefully to
                    understand our views and practices regarding your personal
                    data.
                  </li>
                  <li className="mt-4 text-sm">
                    We collect your personal information in order to provide and
                    continually improve our services.
                  </li>
                  <li className="mt-4 text-sm">
                    Our privacy policy is subject to change at any time without
                    notice. To make sure you are aware of any changes, please
                    review this policy periodically.
                  </li>
                  <li className="mt-4 text-sm">
                    All partner firms and any third party working with or for
                    Us, and who have access to personal information, will be
                    expected to read and comply with this policy. No third party
                    may access, or process sensitive personal information held
                    by Us without having first entered into a confidentiality
                    agreement.
                  </li>
                </ol>
              </li>
              <li className="mt-4 text-sm">
                <p className="font-bold ml-4 text-sm">HOW WE COLLECT THE INFORMATION</p>
                <ol className="list-disc ml-4 text-sm">
                  <li className="mt-4 text-sm">
                    From you directly and through this Site: We may collect
                    information through the Website when you visit. The data we
                    collect depends on the context of your interaction with our
                    website.
                  </li>
                  <li className="mt-4 text-sm">
                    Through business interaction: We may collect information
                    through business interaction with you or your employees.
                  </li>
                  <li className="mt-4 text-sm">
                    From other sources: We may receive information from other
                    sources, such as public databases; joint marketing partners;
                    social media platforms; or other third parties.
                  </li>
                </ol>
              </li>
              <li className="mt-4 text-sm">
                <p className="font-bold ml-4 text-sm">
                  INFORMATION WE COLLECT AND OBTAIN
                </p>
                <p className="mt-4 text-sm">
                  We obtain personal information about you from a variety of
                  sources. This includes personal information you provide to us
                  directly, information we obtain from other sources, and
                  information we gather through automated means.
                </p>
                <p className="mt-4 text-sm">
                  <b>Information you provide to us.</b> When you visit to use
                  the website or participate in certain services, seek access to
                  certain content or features, or directly correspond with us,
                  we may collect certain types of information from you:
                </p>
                <ol className="list-disc mt-4 ml-10 text-sm">
                  <li className="mt-4 text-sm">
                    Contact information (such as name, postal address, email
                    address and telephone and/or mobile numbers);
                  </li>
                  <li className="mt-4 text-sm">
                    Your social security number or payment information, when
                    needed to facilitate certain transactions;
                  </li>
                  <li className="mt-4 text-sm">
                    Reviews, comments, and/or surveys on our media blog; and
                  </li>
                  <li className="mt-4 text-sm">
                    Other information you may provide to us when you fill a
                    form, such as through our <b>"Contact Us"</b> feature.
                  </li>
                </ol>
                <p className="mt-4 text-sm">
                  <b>Information obtained from other sources.</b> We may obtain
                  personal information about you in connection with the Services
                  from publicly and commercially available sources and from our
                  affiliates and/or business partners (such as advertising
                  networks or social networking services), including:
                </p>
                <ol className="list-disc mt-4 ml-10 text-sm">
                  <li className="mt-4 text-sm">
                    <b>Demographic data </b>(such as gender, age range,
                    educational level, household income range, number of
                    children in household, ethnicity to the extent permitted);
                  </li>
                  <li className="mt-4 text-sm">
                    <b>Purchasing data</b>, including information about
                    advertisements you have seen or acted upon and information
                    about your interaction with advertisers’ products and
                    services;
                  </li>
                  <li className="mt-4 text-sm">
                    <b>Occupational data </b>(such as profession, position,
                    title, industry; and business address);
                  </li>
                </ol>
                <p className="mt-4 text-sm">
                  <b>
                    Information Collected by Automated Means through Our
                    Services.
                  </b>
                  We may gather by automated means (such as cookies, web
                  beacons, web server logs, JavaScript and other similar
                  technologies) certain information through our Services:
                </p>
                <ol className="list-disc mt-4 ml-10 text-sm">
                  <li className="mt-4 text-sm">Your Internet Protocol (IP) address;</li>
                  <li className="mt-4 text-sm">
                    Device information, including unique identifiers and
                    connection information, including mobile device advertising
                    IDs (e.g., Apple’s IDFA or Google’s AAID) and the means of
                    internet connection (e.g., WiFi connection, ISP) that can
                    identify the physical location of such devices, in
                    accordance with applicable law;
                  </li>
                  <li className="mt-4 text-sm">
                    Your device type and settings, software used, browser type
                    and operating system;
                  </li>
                  <li className="mt-4 text-sm">
                    Websites or other services you visited before and after
                    visiting the Services (referring URL);
                  </li>
                  <li className="mt-4 text-sm">
                    Web pages and advertisements you view and links you click on
                    within, and what search queries you may have run on, the
                    Services (clickstream);
                  </li>
                  <li className="mt-4 text-sm">
                    Viewing behavior, including the content you view, how long
                    you view content, the quality of the service you receive,
                    and advertisements you have been shown or interacted with;
                  </li>
                  <li className="mt-4 text-sm">
                    Dates and times you access or use the Services;
                  </li>
                  <li className="mt-4 text-sm">
                    Location information, including the city, state and zip code
                    associated with your IP Address, information derived through
                    WiFi triangulation, and precise location information from
                    GPS-based functionality on your mobile apps, with your
                    consent;
                  </li>
                  <li className="mt-4 text-sm">
                    Your phone number and mobile carrier details in connection
                    with our mobile app.
                  </li>
                </ol>
              </li>
              <li className="mt-4 text-sm">
                <p className="font-bold ml-4 text-sm">HOW WE USE YOUR INFORMATION</p>
                <ol className="list-disc mt-4 ml-10 text-sm">
                  <li className="mt-4 text-sm">
                    <b>Provide and Improve Services: </b> We use your
                    information to deliver and improve our services, personalize
                    your experience, and respond to your inquiries or requests.
                  </li>
                  <li className="mt-4 text-sm">
                    <b>Communication: </b>
                    We may use your information to communicate with you, send
                    you important updates, newsletters, and marketing materials,
                    or respond to your comments or feedback.
                  </li>
                  <li className="mt-4 text-sm">
                    <b>Legal Obligation: </b>
                    We may use your information to comply with applicable laws,
                    regulations, or legal processes, and to protect our rights,
                    privacy, safety, or property.
                  </li>
                </ol>
              </li>
              <li className="mt-4text-sm">
                <p className="font-bold ml-4 text-sm">
                  COOKIES AND SIMILAR TECHNOLOGIES
                </p>
                <p className="mt-4 text-sm">
                  Cookies are small files that are sent to and stored on your
                  computer, browser, mobile app, or other application when you
                  access, visit, use, or take advantage of our Services or other
                  media. These cookies help us and our partners recognize your
                  device as unique and provide you with a personalized
                  experience. Cookies may also collect demographic data or be
                  linked to information you submit.
                </p>
                <p className="mt-4 text-sm">
                  One of the uses of cookies is to enable you to receive
                  customized ads, alerts, content, services, or information
                  based on your preferences and interests. However, you are free
                  to decline or manage the use of cookies by adjusting the
                  settings of your browser, if permitted by your browser. It's
                  important to note that disabling cookies may result in some
                  products, services, or features not being available or
                  operating properly.
                </p>
                <p className="mt-4 text-sm">
                  In addition to cookies, we and our service providers may use
                  other data-gathering mechanisms on our Services, such as web
                  beacons, clear GIFs, pixels, or tags. These mechanisms perform
                  statistical and administrative functions, including measuring
                  site and page traffic, verifying advertising paths,
                  better-understanding user interests and activity, and
                  gathering related information such as browser, device, or IP
                  address. These mechanisms are 4 typically designed to enhance
                  your online experience and may not necessarily collect
                  Personal Information.
                </p>
                <p className="mt-4 text-sm">
                  If you have provided your email address, we may use a
                  non-human unreadable form (hash) of your email address to
                  deliver or facilitate the delivery of relevant advertisements
                  and information to you through our Services or other websites
                  or media, including popular social media sites and features.
                </p>
              </li>

              <li className="mt-4 text-sm">
                <p className="font-bold ml-4 text-sm">DATA SECURITY</p>
                <ol className="list-disc mt-4 ml-10 text-sm">
                  <li className="mt-4 text-sm">
                    We take due care to protect customer data. Technical
                    measures are in place to prevent unauthorised or unlawful
                    access to data and against accidental loss or destruction
                    of, or damage to, data. the employees who are dealing with
                    the data have been trained to protect the data from any
                    illegal or unauthorised usage.
                  </li>
                  <li className="mt-4 text-sm">
                    We follow the Payment Card Industry Data Security Standard
                    (PCI DSS) when handling branded credit cards from major card
                    schemes.
                  </li>
                  <li className="mt-4 text-sm">
                    We maintain physical, electronic, and procedural safeguards
                    in connection with the collection, storage, and disclosure
                    of personal customer information.
                  </li>
                  <li className="mt-4 text-sm">
                    We take reasonable steps to help protect your personal
                    information in an effort to prevent loss, misuse and
                    unauthorized access, disclosure alteration, and destruction.
                    It is your responsibility to protect your username and
                    password to prevent anyone from accessing or abusing your
                    account and services, You should not use or reuse the same
                    passwords you use with other accounts as your password for
                    our services.
                  </li>
                  <li className="mt-4 text-sm">
                    It is important for you to protect against unauthorised
                    access to your password and your computer, devices, and
                    applications. be sure to sign off when you finish using a
                    shared computer.
                  </li>
                  <li className="mt-4 text-sm">
                    The information you provide to us is shared on our secured
                    servers. We have implemented appropriate physical,
                    technical, and organizational measures designed to secure
                    your information against accidental loss and unauthorised
                    access, use, alteration, or disclosure. In addition, we
                    limit access to personal data to those employees, agents,
                    contractors, and other third parties that have a legitimate
                    business need for such access.
                  </li>
                  <li className="mt-4 text-sm">
                    Information collected from you will be stored for such
                    period as required to complete the transaction entered into
                    you or such period as mandated under applicable law.
                  </li>
                </ol>
              </li>
              <li className="mt-4 text-sm">
                <p className="font-bold ml-4 text-sm">
                  HOW WE HOLD AND PROTECT YOUR PERSONAL INFORMATION
                </p>
                <p className=" ml-4 text-sm">
                  We are committed to ensuring that your personal information is
                  securely stored and handled in accordance with applicable laws
                  and regulations. We take reasonable steps to protect your
                  personal information and maintain its confidentiality. Please
                  read this section to understand how we keep your personal
                  information secure.
                </p>
                <p className="mt-4 font-bold underline text-sm">Secure Storage:</p>
                <ol className="list-disc mt-4 ml-4 text-sm">
                  <li className="mt-4 text-sm">
                    All information you provide to us is stored on secure
                    servers with appropriate technical and organizational
                    measures in place to protect against unauthorized access,
                    alteration, disclosure, or destruction.
                  </li>
                  <li className="mt-4 text-sm">
                    We regularly review our security measures and update them as
                    necessary to ensure the ongoing confidentiality and
                    integrity of your personal information.
                  </li>
                </ol>

                <p className="mt-4 font-bold underline text-sm">
                  Third-Party Payment Transactions:
                </p>
                <ol className="list-disc mt-4 ml-4 text-sm">
                  <li className="mt-4 text-sm">
                    Any payment transactions you initiate on our site will be
                    carried out by trusted third-party payment processors using
                    secure and encrypted connections, such as SSL technology.
                  </li>
                  <li className="mt-4 text-sm">
                    These third-party payment processors have their own privacy
                    and security measures in place to protect your payment
                    information. We encourage you to review their privacy
                    policies and practices.
                  </li>
                </ol>
                <p className="mt-4 text-sm font-bold underline">
                  Password and API Key Protection:
                </p>
                <ol className="text-sm list-disc mt-4 ml-4">
                  <li className="mt-4 text-sm">
                    If we have provided you with a password or API key to access
                    certain parts of our site or apps, it is your responsibility
                    to keep this information confidential and secure.
                  </li>
                  <li className="mt-4 text-sm">
                    We request that you do not share your password or API key
                    with anyone else to prevent unauthorized access to your
                    account or sensitive information.
                  </li>
                </ol>
                <p className="mt-4 text-sm font-bold underline">
                  Internet Transmission Risks:
                </p>
                <ol className="list-disc mt-4 ml-4 text-sm">
                  <li className="mt-4 text-sm">
                    While we strive to protect your personal information, please
                    note that the transmission of data over the internet is not
                    entirely secure. Any transmission of information to our site
                    is done at your own risk.
                  </li>
                  <li className="mt-4 text-sm">
                    Once we receive your information, we employ strict
                    procedures and security features to prevent unauthorized
                    access, but we cannot guarantee the absolute security of
                    your data during transmission.
                  </li>
                </ol>
                <p className="mt-4 text-sm">
                  It is important to regularly review and update your personal
                  information to ensure its accuracy and promptly notify us of
                  any unauthorized use or security breaches.
                </p>
              </li>
              <li className="mt-4 text-sm">
                <p className="font-bold ml-4 text-sm">
                  SHARING OF PERSONAL INFORMATION
                </p>
                <p className="mt-4 text-sm">
                  We do not share your personal data with third parties without
                  your prior consent or other than:
                </p>
                <ol className="list-disc mt-4 text-sm">
                  <li className="mt-4 ml-4 text-sm">
                    With third parties who work on our behalf provided such
                    third parties adhere to the data protection principles set
                    out in the IT Act, 2000 (21 of 2000) and other applicable
                    legislation, or enter into a written agreement with Us
                    requiring the third party provide at least the same level of
                    privacy protection as is required by such principles;{" "}
                  </li>
                  <li className="mt-4 ml-4 text-sm">
                    To comply with laws or to respond to lawful requests and
                    legal processes;{" "}
                  </li>
                  <li className="mt-4 ml-4 text-sm">
                    To protect the rights and property of Us, our agents,
                    customers, and others including to enforce our agreement,
                    policies, and terms of use;{" "}
                  </li>
                  <li className="mt-4 ml-4 text-sm">
                    For the purpose of a business deal (or negotiation of a
                    business deal) involving the sale or transfer of all or a
                    part of our business or assets (business deals may include,
                    for example, any merger, financing, acquisition,
                    divestiture, or bankruptcy transaction or proceeding)
                  </li>
                </ol>
              </li>
              <li className="mt-4 text-sm">
                <p className="font-bold ml-4 text-sm">CHILDREN AND MINOR</p>
                <p className="mt-4 text-sm">
                  If you are under 18, or the age of majority in the
                  jurisdiction in which you reside, you may only use our website
                  with the consent of your parent or legal guardian. in any
                  case, we will not be liable for any cause of action that
                  arouse due to non-compliance with this section.
                </p>
                <p className="mt-4 text-sm">
                  If we become aware that one of our users or visitors is a
                  minor under the age specified by applicable laws, we will take
                  immediate steps to remove their personal information from our
                  records. We are committed to protecting the privacy and safety
                  of minors who use our services.
                </p>
                <p className="mt-4 text-sm">
                  If you believe that we have processed or continue to hold
                  personal information of a minor without appropriate consent or
                  in violation of applicable laws, please contact us via email
                  at <mark>[contact@CarRental.app]</mark>. We will promptly
                  investigate the matter and take necessary actions to remove
                  the information from our systems as soon as possible.
                </p>
                <p className="mt-4 text-sm">
                  We encourage parents or legal guardians to monitor and
                  supervise the online activities of minors under their care to
                  ensure their privacy and safety.
                </p>
              </li>
              <li className="mt-4 text-sm">
                <p className="font-bold ml-4 text-sm">
                  GDPR COMPLIANCE FOR EXTRATERRITORIAL REACH:
                </p>
                <p className="mt-4 text-sm">
                  We recognize and respect the privacy rights of individuals,
                  including those located in the European Union (EU). Although
                  we are based outside the EU, we understand that our services
                  may be accessed by individuals within the EU or involve the
                  collection and processing of personal data of EU individuals.
                  Therefore, we strive to comply with the provisions of the
                  General Data Protection Regulation (GDPR) to the extent
                  applicable to our operations.
                </p>
                <p className="mt-4 text-sm">
                  The GDPR establishes certain rights and obligations concerning
                  the processing of personal data, including the collection,
                  use, retention, and security of such data. As a business
                  outside the EU, we are committed to upholding the principles
                  and requirements of the GDPR when handling personal data of
                  individuals located in the EU or subject to the GDPR.
                </p>
                <p className="mt-4 text-sm">
                  While we make reasonable efforts to comply with the GDPR,
                  please note that certain provisions may not apply to us or our
                  operations due to our location and specific circumstances.
                  However, we are committed to implementing suitable data
                  protection measures to safeguard personal data and respect the
                  privacy rights of all individuals, regardless of their
                  location.
                </p>
                <p className="mt-4 text-sm">
                  If you are located in the EU or otherwise subject to the GDPR,
                  please be aware that by using our services or providing your
                  personal data to us, you acknowledge and agree that your
                  personal data may be transferred, processed, and stored
                  outside the EU, including in jurisdictions that may have
                  different data protection laws. We take appropriate steps to
                  ensure the protection of personal data, including implementing
                  appropriate safeguards, such as Standard Contractual Clauses
                  (SCCs) or other lawful mechanisms, as required by the GDPR.
                </p>
                <p className="mt-4 text-sm">
                  If you have any questions or concerns about our privacy
                  practices, the processing of your personal data, or your
                  rights under the GDPR, please contact us using the information
                  provided in the 'Contact Us' section of this privacy policy.
                </p>
                <p className="mt-4 text-sm">
                  By using our services, you signify your understanding and
                  acceptance of this GDPR clause and our commitment to
                  protecting your personal data in accordance with applicable
                  data protection laws, including the GDPR."
                </p>
              </li>
              <li className="mt-4 text-sm">
                <p className="font-bold ml-4">
                  OUR RETENTION OF YOUR PERSONAL INFORMATION
                </p>
                <p className="mt-4 text-sm">
                  The retention periods for your personal information will
                  depend on the purpose for which the information was collected
                  and the specific use cases. We will not retain your personal
                  information for longer than necessary, except for our
                  legitimate business purposes or as required by applicable laws
                  and regulations.
                </p>
                <ol className="mt-4 text-sm list-decimal">
                  <li className="">
                    <p className="mt-4 text-sm font-bold underline">
                      Business Purposes:
                    </p>
                    <ol className="mt-4 text-sm list-disc ml-4">
                      <li className="mt-4 text-sm">
                        We may retain your personal information for as long as
                        necessary to provide you with the services or products
                        you have requested from us.
                      </li>
                      <li className="mt-4 text-sm">
                        Additionally, we may retain your personal information
                        for internal administrative purposes, such as
                        record-keeping, analytics, and improving our services.
                      </li>
                    </ol>
                  </li>
                  <li className="">
                    <p className="mt-4 text-sm font-bold underline">
                      Legal Requirements:
                    </p>
                    <ol className="mt-4 text-sm list-disc ml-4">
                      <li className="mt-4 text-sm">
                        We may retain your personal information for a longer
                        period if required to comply with legal obligations
                        imposed on us by applicable laws, regulations, or
                        governmental authorities.
                      </li>
                      <li className="mt-4 text-sm">
                        This may include retaining your personal information to
                        resolve disputes, enforce our agreements, or protect our
                        legal rights and interests.
                      </li>
                    </ol>
                  </li>
                  <li className="">
                    <p className="mt-4 text-sm font-bold underline">
                      Data Minimization:
                    </p>
                    <ol className="mt-4 text-sm list-disc ml-4">
                      <li className="mt-4 text-sm">
                        We strive to only collect and retain personal
                        information that is necessary and relevant for the
                        purposes for which it was collected.
                      </li>
                      <li className="mt-4 text-sm">
                        We periodically review the personal information we hold
                        and take reasonable steps to delete or anonymize any
                        personal information that is no longer necessary for the
                        stated purposes.
                      </li>
                    </ol>
                  </li>
                  <li className="">
                    <p className="mt-4 text-sm font-bold underline">User Choices:</p>
                    <ol className="mt-4 text-sm list-disc ml-4">
                      <li className="mt-4 text-sm">
                        You have the right to request the deletion or erasure of
                        your personal information, subject to any legal
                        obligations or legitimate interests that may require its
                        retention.
                      </li>
                      <li className="mt-4 text-sm">
                        Please refer to our Privacy Policy for information on
                        how to exercise your rights and make such requests.
                      </li>
                    </ol>
                  </li>
                  <p className="mt-4 text-sm">
                    Please note that even after the deletion of your personal
                    information, we may retain certain data as necessary for our
                    legitimate business purposes or to comply with legal
                    obligations.
                  </p>
                </ol>
              </li>
              <li className="mt-4 text-sm">
                <p className="font-bold text-sm">YOUR RIGHTS TO YOUR DATA</p>
                <ol className="list-disc">
                  <li>
                    <p className="font-bold text-sm underline mt-4">Right to Access:</p>
                    <p className="mt-4 text-sm">
                      {" "}
                      You have the right to request access to the personal data
                      we hold about you. Upon receiving such a request, we will
                      provide you with a copy of the personal data we have on
                      record, along with information about how it is being
                      processed.
                    </p>
                  </li>
                  <li>
                    <p className="font-bold underline text-sm mt-4">
                      Right to Rectification:
                    </p>
                    <p className="mt-4 text-sm">
                      If you believe that the personal data we hold about you is
                      inaccurate or incomplete, you have the right to request
                      the correction or amendment of that information. We will
                      make reasonable efforts to ensure that your personal data
                      is accurate and up to date.
                    </p>
                  </li>
                  <li>
                    <p className="font-bold underline mt-4 text-sm">
                      Right to Erasure:
                    </p>
                    <p className="mt-4 text-sm">
                      {" "}
                      You have the right to request the deletion or removal of
                      your personal data under certain circumstances, such as
                      when the data is no longer necessary for the purposes for
                      which it was collected or if you withdraw your consent.
                      However, please note that we may have legal or legitimate
                      grounds to retain certain data even upon your request for
                      deletion.
                    </p>
                  </li>
                  <li>
                    <p className="font-bold underline mt-4 text-sm">
                      Right to Restrict Processing:
                    </p>
                    <p className="mt-4 text-sm">
                      {" "}
                      In some cases, you may have the right to request that we
                      limit the processing of your personal data, such as when
                      you contest the accuracy of the data or when the
                      processing is unlawful.
                    </p>
                  </li>
                  <li>
                    <p className="font-bold underline mt-4 text-sm">
                      Right to Data Portability:
                    </p>
                    <p className="mt-4 text-sm">
                      {" "}
                      If you provided your personal data to us and the
                      processing is based on your consent or the performance of
                      a contract, you have the right to receive that data in a
                      structured, commonly used, and machine-readable format.
                      You may also have the right to request that we transmit
                      the data to another controller where technically feasible.
                    </p>
                  </li>
                  <li>
                    <p className="font-bold underline mt-4 text-sm">Right to Object:</p>
                    <p className="mt-4 text-sm">
                      {" "}
                      You have the right to object to the processing of your
                      personal data, based on legitimate interests or for direct
                      marketing purposes. In such cases, we will stop processing
                      your personal data unless we can demonstrate compelling
                      legitimate grounds for the processing that override your
                      interests, rights, and freedoms.
                    </p>
                  </li>
                  <li>
                    <p className="font-bold underline mt-4 text-sm">
                      Right to Withdraw Consent:
                    </p>
                    <p className="mt-4 text-sm">
                      {" "}
                      If we rely on your consent as the legal basis for
                      processing your personal data, you have the right to
                      withdraw that consent at any time. The withdrawal of
                      consent does not affect the lawfulness of processing based
                      on consent before its withdrawal.
                    </p>
                  </li>
                  <p className="mt-4 text-sm">
                    To exercise your rights, or if you have any questions or
                    concerns regarding the processing of your personal data,
                    please contact us using the contact details provided in our
                    Privacy Policy.
                  </p>
                  <p className="mt-4 text-sm">
                    Please note that there may be limitations or exceptions to
                    these rights as per applicable laws and regulations.
                  </p>
                </ol>
              </li>
              <li className="mt-4 text-sm">
                <p className="font-bold text-sm ">CHANGES TO POLICY</p>
                <p className="mt-4 text-sm">
                  We may change this policy from time to time. If we make any
                  changes to this policy, we will change the "Last Update" You
                  agree that your continued use of our services after such
                  changes have been published to our services will constitute
                  your acceptance of such revised policy.
                </p>
                <p className="mt-4 text-sm">
                  If you have any concern about privacy or grievance with Us,
                  please contact us with a thorough description and we will try
                  to resolve the issue for you.
                </p>
              </li>
              <li className="mt-4 text-sm">
                <p className="font-bold text-sm ">JURISDICTION</p>
                <p className="mt-4 text-sm">
                  {" "}
                  If you choose to visit the website, your visit and any dispute
                  over privacy is subject to this Policy and the website's terms
                  of use. In addition to the foregoing, any disputes arising
                  under this Policy shall be governed by the laws of India.
                </p>
              </li>
              <li className="mt-4 text-sm">
                <p className="font-bold text-sm ">CONTACT US</p>
                <p className="mt-4 text-sm">
                  If you have any questions, concerns, or requests regarding
                  this Privacy Policy, please contact us at:
                </p>
                <p className="mt-4 text-sm">Email: contact@CarRental.app</p>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
